import { css } from '@emotion/react'
import { size, width } from '@twistopayments/design-system/styles'

export const section = css`
  margin: ${size[60]} auto;
  max-width: ${width.container.wider};
  padding: 0 ${size[20]};
`
